import { action } from 'easy-peasy';
import { IActionSetCarePlanHospitalizations } from '../types';

const setCarePlanHospitalizations: IActionSetCarePlanHospitalizations = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanHospitalizations;
